import { FlowRouteCategory } from '@eneco/flows/types';

import { CustomerDetailsStep } from '../../../shared/steps';
import { TestConfigVariant } from '../../types/experiment';

/**
 * A/B test exp-n-477: single-page customer details.
 *
 * Variant B replaces the separate PERSONAL_DETAILS and CONTACT_DETAILS steps
 * with one combined step. Variant A is the untouched production flow (the
 * two-step version).
 *
 * The combined step reuses the `PERSONAL_DETAILS` route in place — same id and
 * same path, only the component changes. Keeping the id means the summary step's
 * "edit personal details" action (`GOTO STEP_PERSONAL_DETAILS`) still resolves,
 * and keeping the path means the route still maps to the existing Sitecore page,
 * so the shared navigation chrome (step labels, back link, help/close) renders.
 * The step's own copy comes from its bundled i18n dictionary, not Sitecore.
 * Only CONTACT_DETAILS is removed, as its fields now live in the combined step.
 */
export const exp_n_477_B: TestConfigVariant = {
  testKey: 'exp-n-477-personal-details-consolidation',
  variant: 'B',
  routes: [
    {
      id: 'PERSONAL_DETAILS',
      path: '/je-gegevens/persoonlijke-gegevens/',
      category: FlowRouteCategory.Details,
      component: CustomerDetailsStep,
    },
  ],
  removeRouteIds: ['CONTACT_DETAILS'],
};
